module.exports = __webpack_public_path__ + "img/30cc3a9.png";